/**
 * Enumeration of all webshop events
 */
export enum WebshopEvent {
    /** Represents the Welcome event */
    Welcome = "welcome",

    /** Represents a filter change from the sidebar */
    FilterChange = "filter-change",
}
